<template>
    <div class="card-body">
        <div class="">
           <h4 class="card-title mb-2">{{ $t("overview.data-completeness-note") }}</h4>
            <!-- <b-button variant="primary" class="btn btn-sm m-1" @click="ProgressData"> Detail </b-button> -->
            <a href="#" class="text-info" @click="ProgressData" v-if="id_template == 1 || id_template == 5">
                <b-progress :max="100" height="15px">
                    <b-progress-bar :value="(progress_data_count/16)*100" :label="`${((progress_data_count / 16) * 100)} %`" show-value animated></b-progress-bar>
                </b-progress>
            </a>

            <a href="#" class="text-info" @click="ProgressData" v-else>
                <b-progress :max="100" height="15px">
                    <b-progress-bar :value="(progress_data_count/9)*100" :label="`${((progress_data_count / 9) * 100)} %`" show-value animated></b-progress-bar>
                </b-progress>
            </a>
        </div>  
        <simplebar style="max-height: 50vh;" class="mt-3">
           <div class="row mt-2" style="max-height: 50vh; min-height:50vh; max-width: 100%">
                <div class="col-md-12">
                <span>*{{ $t("overview.note") }}</span>
                    <div class="form-group">
                        <!-- <ckeditor class="ck" v-model="text_editor" :editor="editor" :config="editorConfig"></ckeditor> -->
                        <editor
                            api-key="i93w8h2gvx8u90z3wr2rf9ski2yasqqyyr7vf22lcm1p4nkx"
                            :init="options"
                            v-model="text_editor"
                        ></editor>
                    </div>
                </div>  
                <div class="col-md-12 text-right">
                    <div class="form-group">
                       <b-button class="btn btn-sm" variant="primary" @click="updateNote"> Update </b-button>
                    </div>
                </div>
            </div> 
        </simplebar>
        <b-modal
            size="lg"
            ref="modal-progress-data"
            :id="'modal-progress-data'"
            centered
            title="Proggres Data"
            title-class="font-18"
            hide-footer
            >
            <div class="row">
                    <div class="col-12">
                        <div class="mt-4">
                    <ul class="verti-timeline list-unstyled">
                        <li class="event-list">
                        <div class="event-timeline-dot">
                            <i class="bx bx-user-circle h4"></i>
                        </div>
                        <div class="media">
                            <div class="mr-2">
                            <!-- <i class="bx bx-user-pin h2 text-primary"></i> -->
                            </div>
                            <div class="media-body">
                            <div>
                                <h5 class="font-size-14">{{ $t("overview.table.all.private-data") }}</h5>
                                <span class="text-muted">
                                    <b-form-checkbox
                                        v-model="privateData.citizen" 
                                        disabled
                                        class="mb-1"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    Citizen
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="privateData.phone" 
                                        disabled
                                        class=" mb-1"
                                        > 
                                    {{$t("overview.table.all.phone")}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="privateData.email" 
                                        disabled
                                        class=" mb-1"> 
                                    Email
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="privateData.tags"
                                        disabled 
                                        class="mt-0"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    Tags
                                    </b-form-checkbox>
                                </span>
                            </div>
                        </div>
                        </div>
                        </li>
                        <li class="event-list">
                        <div class="event-timeline-dot">
                            <i class="bx bxl-twitter h4"></i>
                        </div>
                        <div class="media">
                            <div class="mr-2">
                            <!-- <i class="bx bxl-twitter h2 text-primary"></i> -->
                            </div>
                            <div class="media-body">
                            <div>
                                <h5 class="font-size-14">{{ $t("overview.social-media") }}</h5>
                                <span class="text-muted">
                                    <b-form-checkbox
                                        v-model="socialMedia.twitter" 
                                        disabled
                                        class="mb-1"> 
                                    Twitter
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="socialMedia.instagram"
                                        disabled 
                                        class="mb-1"> 
                                    Instagram
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="socialMedia.telegram"
                                        disabled 
                                        class="mt-0"> 
                                    Telegram
                                    </b-form-checkbox>
                                </span>
                            </div>
                            </div>
                        </div>
                        </li>

                        <li class="event-list">
                        <div class="event-timeline-dot">
                            <i class="bx bx-data h4"></i>
                        </div>
                        <div class="media">
                            <div class="mr-2">
                            <!-- <i class="bx bx-data h2 text-primary"></i> -->
                            </div>
                            <div class="media-body">
                            <div>
                                <h5 class="font-size-14">{{ $t("overview.advanced") }}</h5>
                                <span class="text-muted">
                                <b-form-checkbox
                                        v-model="advancedData.education" 
                                        disabled
                                        class="mb-1"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    {{$t('advanced.education')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="advancedData.career"
                                        disabled 
                                        class="mb-1"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    {{$t('advanced.career')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="advancedData.social_media"
                                        disabled 
                                        class="mt-0"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    {{$t('advanced.social-media-database')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="advancedData.ecommerce" 
                                        disabled
                                        class="mb-1"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    {{$t('advanced.social-media-database')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="advancedData.potential_breach"
                                        disabled 
                                        class=" mb-1"
                                        > 
                                    {{$t('advanced.social-media-database')}}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="advancedData.website"
                                        disabled 
                                        class="mt-0"> 
                                    Website
                                    </b-form-checkbox>
                                </span>
                            </div>
                            </div>
                        </div>
                        </li>

                        <li class="event-list">
                        <div class="event-timeline-dot">
                            <i class="bx bx-user-pin h4"></i>
                        </div>
                        <div class="media">
                            <div class="mr-2">
                                <i class="bx bx-list h2 text-primary"></i>
                            </div>
                            <div class="media-body">
                            <div>
                                <h5 class="font-size-14">Etc</h5>
                                <span class="text-muted">
                                    <b-form-checkbox
                                        v-model="etc.image_analys" 
                                        disabled
                                        class="mb-1"
                                        v-if="id_template == 1 || id_template == 5"
                                        > 
                                    {{ $t('overview.image-analys') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="etc.related_news"
                                        disabled
                                        class=" mb-1"> 
                                    {{ $t('news.related-news') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="etc.canvas"
                                        disabled 
                                        class="mt-0"> 
                                    Canvas
                                    </b-form-checkbox>
                                </span> <br>
                            </div>
                            </div>
                        </div>
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
import {gmapApi} from 'vue2-google-maps'
import TargetService from "@/helpers/target-profile.service";
import NewsService from "@/helpers/news.service.js";
import Swal from "sweetalert2";
import moment from 'moment';
import simplebar from "simplebar-vue";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Editor from "@tinymce/tinymce-vue";

export default {
  props: ['id_target', 'id_analys', 'manager', 'id_user', 'user_type', 'id_template'],
  
 components: { simplebar, 
    ckeditor: CKEditor.component, Editor },
  data() {
    return {
      id: this.id_target,
      target: "",
      editor: ClassicEditor,
      editorData:"<h5><br><br></h5>",
      editorConfig: {
        
      },
      text_editor: "",
      loading: false,
      loadingnew: false,
      title: "Progress",
      progress_data_count:0,
      privateData:{
        citizen: false,
        phone: false,
        email: false,
        tags: false
      },
      socialMedia:{
        twitter: false,
        instagram: false,
        telegram: false
      },
      advancedData:{
        education: false,
        career: false,
        social_media: false,
        ecommerce: false,
        potential_breach: false,
        website: false
      },
      etc:{
        image_analys: false,
        related_news: false,
        canvas: false
      },
        options: {
        height: 450,
        skin: localStorage.getItem("theme") == "dark" ? "oxide-dark" : "",
        content_css: localStorage.getItem("theme") == "dark" ? "dark" : "",
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        toolbar:
          "undo redo | fontselect | fontsizeselect | formatselect | bold underline italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat image table | help",
        image_title: true,
        /* enable automatic uploads of images represented by blob or data URIs*/
        automatic_uploads: true,
        file_picker_types: "image",
        file_picker_callback: function (callback, value, meta) {
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.onchange = function () {
            var file = this.files[0];
            var reader = new FileReader();
            reader.onload = function () {
              var id = "blobid" + new Date().getTime();
              var blobCache = tinymce.activeEditor.editorUpload.blobCache;
              var base64 = reader.result.split(",")[1];
              var blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);
              callback(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);
          };
          input.click();
        },
        }
    }
  },
  methods: {
        ProgressData(){
            this.$bvModal.show("modal-progress-data");
        },

        async getTargetDetail() {
            await TargetService.getDetailTarget(this.id)
            .then((response) => {
            // console.log('asdasdadasda',response.data.data);
                this.text_editor = response.data.data.other_description;
            })
            .catch((err) => {
                console.log("d target -> ", err);
            });
        },

        updateNote(){
            // console.log('update note', this.text_editor);
            let data = {
                other_description: this.text_editor,
            };
            TargetService.updateTargetProfile(this.id, data)
            .then((response) => {
                Vue.swal({
                position: "top-end",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
                });
                this.getTargetDetail();
            //    console.log('resspon', response.data.data); 
            })
            .catch((err) => {
                console.log(err);
            });
        },

        getProgress() {
            // console.log('progress');
            this.loading = true;
            TargetService.getTargetProgress(this.id)
            .then((response) => {
                let val = response.data.data;
                // console.log('res', val);
                this.privateData.citizen = val.citizen; 

                if(val.email !== 'false'){
                    this.privateData.email = true; 
                }
                if(val.phone !== 'false'){
                    this.privateData.phone = true; 
                }
                if(val.tags !== 'false'){
                    this.privateData.tags = true; 
                }
                if(val.website !== 'false'){
                    this.advancedData.website = true; 
                }
                if(val.potential !== 'false'){
                    this.advancedData.potential_breach = true; 
                }
                if(val.related_news !== 'false'){
                    this.etc.related_news = true; 
                }
                if(val.image_analys !== 'false'){
                    this.etc.image_analys = true; 
                }

                this.socialMedia.twitter = val.twitter; 
                this.socialMedia.instagram = val.instagram; 
                this.socialMedia.telegram = val.telegram;
                this.advancedData.education = val.education;
                this.advancedData.career = val.career;
                this.advancedData.social_media = val.sosmed;
                this.advancedData.ecommerce = val.ecommerce;
                this.etc.canvas = val.canvas;

                let data = response.data.data;
                let datax = JSON.stringify(data);
                // console.log(datax);

                if(val.citizen == true){
                    this.progress_data_count = this.progress_data_count+1; 
                } 
                if(val.email !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.phone !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.tags !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
                } 
                if(val.twitter == true){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.instagram == true){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.telegram == true){
                    this.progress_data_count = this.progress_data_count+1; 
                } 
                if(val.education == true){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.career == true){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.sosmed == true){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.ecommerce == true){
                    this.progress_data_count = this.progress_data_count+1; 
                } 
                if(val.potential !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
                }
                if(val.website !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
               }
                if(val.image_analys !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
               } 
               if(val.related_news !== 'false'){
                    this.progress_data_count = this.progress_data_count+1; 
               }
               if(val.canvas == true){
                    this.progress_data_count = this.progress_data_count+1; 
               }
                this.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
            });
            }

            // formatDate(value){
            //   return moment(value).format("YYYY-MM-DD, ");
            // },
        },
        mounted(){
            this.getTargetDetail();
            this.getProgress();
        },
};
</script>

<style scoped>
.tiny-dark-mode .tox .tox-menubar {
  background-color: #022b3a;
}
.tiny-dark-mode .tox .tox-statusbar {
  background-color: #022b3a;
}
.tiny-dark-mode .tox .tox-toolbar-overlord {
  background-color: #022b3a !important;
}
.tiny-dark-mode .tox .tox-toolbar-overlord .tox-toolbar__primary {
  background-color: #022b3a !important;
}
.tiny-dark-mode .tox iframe {
  /* filter: invert(37%) sepia(22%) saturate(3928%) hue-rotate(166deg)
    brightness(101%) contrast(95%); */
  filter: opacity(70%);
  color: #fff;
}
.tox-notifications-container {
  position: absolute;
  left: -1120px !important;
  bottom: 0px !important;
  max-height: 947px;
}

</style>